import React, { ReactElement } from 'react';
import oauthLogoGoogleSrc from '../assets/oauth-logo-google.svg';
import { ButtonProps } from './Common';
import OauthButton from './OauthButton';

const GoogleButton = (props: ButtonProps): ReactElement => {
  return <OauthButton {...props} iconSrc={oauthLogoGoogleSrc} />;
};

export default GoogleButton;
